// Custom always-visible scroll indicator for the horizontally-scrolling
// pack-size cards on mobile. Native mobile scrollbars (especially iOS
// Safari) only appear transiently during an active touch-scroll and
// largely ignore ::-webkit-scrollbar styling, so there's no CSS-only way
// to keep a real scrollbar permanently visible — this renders a thin
// track+thumb bar under the cards and keeps it in sync with actual scroll
// position/extent via JS instead.
(function () {
  function setUpTrack(list) {
    var scope = list.closest(".wt-product__option__body--pack-cards") || list.parentElement;
    var track = scope.querySelector(".pack-cards__scroll-track");
    var thumb = track
      ? track.querySelector(".pack-cards__scroll-thumb")
      : null;
    if (!track || !thumb) return;

    function update() {
      var maxScrollLeft = list.scrollWidth - list.clientWidth;
      if (maxScrollLeft <= 1) {
        track.style.display = "none";
        return;
      }
      track.style.display = "";

      var trackWidth = track.clientWidth;
      var thumbWidth = Math.max(
        (list.clientWidth / list.scrollWidth) * trackWidth,
        24,
      );
      var maxThumbLeft = trackWidth - thumbWidth;
      var thumbLeft = (list.scrollLeft / maxScrollLeft) * maxThumbLeft;

      thumb.style.width = thumbWidth + "px";
      thumb.style.transform = "translateX(" + thumbLeft + "px)";
    }

    list.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function init() {
    document
      .querySelectorAll(".pack-cards__list")
      .forEach(setUpTrack);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
